<template>
  <div
    class="cover-letter-overlay"
    @click="close"
  >
    <div
      class="cover-letter-modal"
      @click.stop
    >

      <!-- =====================================================
           DECOR
      ====================================================== -->

      <div class="ambient-glow glow-left"></div>
      <div class="ambient-glow glow-right"></div>


      <!-- =====================================================
           HEADER
      ====================================================== -->

      <div class="modal-header">

        <div class="header-main">

          <div class="ai-icon">
            <svg
              viewBox="0 0 28 28"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M14 3.5L16 10.1L22.5 12L16 14L14 20.5L12 14L5.5 12L12 10.1L14 3.5Z"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linejoin="round"
              />

              <path
                d="M21.5 18L22.3 20.2L24.5 21L22.3 21.8L21.5 24L20.7 21.8L18.5 21L20.7 20.2L21.5 18Z"
                stroke="currentColor"
                stroke-width="1.3"
                stroke-linejoin="round"
              />
            </svg>
          </div>


          <div class="header-text">

            <div class="ai-badge">
              AI сопроводительное письмо
            </div>

            <h2 class="title">
              {{ letter.title }}
            </h2>

            <p class="header-description">
              Письмо готово. Проверьте текст перед отправкой работодателю.
            </p>

          </div>

        </div>


        <button
          type="button"
          class="close-btn"
          aria-label="Закрыть"
          @click="close"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M7 7L17 17"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <path
              d="M17 7L7 17"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />
          </svg>
        </button>

      </div>


      <!-- =====================================================
           LETTER
      ====================================================== -->

      <div class="letter-scroll">

        <div class="letter-paper">

          <!-- INTRO -->

          <div class="letter-section">

            <div class="section-marker">
              <span></span>

              Письмо
            </div>

            <p class="letter-body">
              {{ letter.body }}
            </p>

          </div>


          <!-- REASONS -->

          <div
            v-if="letter.reasons?.length"
            class="letter-section reasons-section"
          >

            <div class="section-marker">
              <span></span>

              Почему вы подходите
            </div>


            <div class="reasons">

              <div
                v-for="(reason, index) in letter.reasons"
                :key="index"
                class="reason-item"
              >

                <div class="reason-check">

                  <svg
                    viewBox="0 0 18 18"
                    fill="none"
                    aria-hidden="true"
                  >
                    <path
                      d="M4.5 9.2L7.4 12L13.5 5.9"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                </div>

                <span>
                  {{ reason }}
                </span>

              </div>

            </div>

          </div>


          <!-- CLOSING -->

          <div
            v-if="letter.closing"
            class="letter-closing"
          >
            {{ letter.closing }}
          </div>

        </div>


        <!-- ===================================================
             INFO
        ==================================================== -->

        <div class="letter-info">

          <div class="info-icon">

            <svg
              viewBox="0 0 24 24"
              fill="none"
            >
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="currentColor"
                stroke-width="1.5"
              />

              <path
                d="M12 10.5V16"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
              />

              <circle
                cx="12"
                cy="7.4"
                r="0.9"
                fill="currentColor"
              />
            </svg>

          </div>

          <span>
            Перед отправкой внимательно проверьте текст.
            AI мог сформулировать отдельные детали неточно.
          </span>

        </div>

      </div>


      <!-- =====================================================
           ACTIONS
      ====================================================== -->

      <div class="actions">

        <button
          type="button"
          class="copy-btn"
          @click="copyLetter"
        >

          <Transition
            name="button-content"
            mode="out-in"
          >

            <span
              v-if="copied"
              key="copied"
              class="button-inner"
            >
              <svg
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M4.5 10L8.2 13.5L15.5 6.5"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              Скопировано
            </span>


            <span
              v-else
              key="copy"
              class="button-inner"
            >
              <svg
                viewBox="0 0 20 20"
                fill="none"
              >
                <rect
                  x="6"
                  y="6"
                  width="9"
                  height="10"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.5"
                />

                <path
                  d="M5 13H4.5C3.67 13 3 12.33 3 11.5V4.5C3 3.67 3.67 3 4.5 3H11.5C12.33 3 13 3.67 13 4.5V5"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>

              Скопировать
            </span>

          </Transition>

        </button>


        <button
          type="button"
          class="send-btn"
          @click="emit('send')"
        >

          <span>
            Отправить работодателю
          </span>

          <svg
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4 10H15"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
            />

            <path
              d="M11 6L15 10L11 14"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

        </button>

      </div>


      <!-- =====================================================
           COPY TOAST
      ====================================================== -->

      <Transition name="copy-toast">

        <div
          v-if="copied"
          class="copy-toast"
        >

          <div class="copy-toast-icon">

            <svg
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M4 9L7.2 12L14 5.5"
                stroke="currentColor"
                stroke-width="1.7"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

          </div>

          Текст скопирован

        </div>

      </Transition>

    </div>
  </div>
</template>


<script setup>

import {
  onBeforeUnmount,
  onMounted,
  ref
} from "vue";


const props = defineProps({

  letter: {
    type: Object,
    required: true
  }

});


const emit = defineEmits([
  "close",
  "send"
]);


const copied =
  ref(false);


let copiedTimer =
  null;


/* =========================================================
   CLOSE
========================================================= */

function close() {

  emit("close");

}


/* =========================================================
   COPY
========================================================= */

async function copyLetter() {

  const reasons =
    Array.isArray(
      props.letter.reasons
    )
      ? props.letter.reasons
      : [];


  const text = [
    props.letter.title,
    "",
    props.letter.body,
    "",
    reasons.length
      ? "Почему я подхожу:"
      : "",
    ...reasons.map(
      reason =>
        `- ${reason}`
    ),
    "",
    props.letter.closing
  ]
    .filter(
      value =>
        value !== null &&
        value !== undefined
    )
    .join("\n")
    .trim();


  try {

    await navigator.clipboard
      .writeText(
        text
      );


    copied.value =
      true;


    if (copiedTimer) {

      window.clearTimeout(
        copiedTimer
      );

    }


    copiedTimer =
      window.setTimeout(
        () => {

          copied.value =
            false;

        },
        1600
      );

  } catch (error) {

    console.error(
      "❌ Copy failed:",
      error
    );

  }

}


/* =========================================================
   ESCAPE
========================================================= */

function handleKeyDown(
  event
) {

  if (
    event.key === "Escape"
  ) {

    close();

  }

}


/* =========================================================
   LIFECYCLE
========================================================= */

onMounted(
  () => {

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

  }
);


onBeforeUnmount(
  () => {

    window.removeEventListener(
      "keydown",
      handleKeyDown
    );


    if (copiedTimer) {

      window.clearTimeout(
        copiedTimer
      );

    }

  }
);

</script>


<style scoped>

/* =========================================================
   OVERLAY
========================================================= */

.cover-letter-overlay {
  position:
    fixed;

  inset:
    0;

  z-index:
    99999;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  box-sizing:
    border-box;

  padding:
    24px;

  background:
    rgba(
      16,
      22,
      32,
      0.40
    );

  backdrop-filter:
    blur(11px);

  -webkit-backdrop-filter:
    blur(11px);
}


/* =========================================================
   MODAL
========================================================= */

.cover-letter-modal {
  position:
    relative;

  width:
    680px;

  max-width:
    calc(100vw - 32px);

  max-height:
    min(
      880px,
      calc(100vh - 40px)
    );

  display:
    flex;

  flex-direction:
    column;

  overflow:
    hidden;

  background:
    rgba(
      255,
      255,
      255,
      0.985
    );

  border:
    1px solid
    rgba(
      27,
      43,
      64,
      0.08
    );

  border-radius:
    24px;

  box-shadow:
    0
    32px
    90px
    rgba(
      15,
      23,
      42,
      0.22
    );

  animation:
    modal-appearance
    0.28s
    cubic-bezier(
      0.2,
      0.8,
      0.3,
      1
    );
}


/* =========================================================
   AMBIENT
========================================================= */

.ambient-glow {
  position:
    absolute;

  pointer-events:
    none;

  border-radius:
    50%;
}


.glow-left {
  top:
    -130px;

  left:
    -120px;

  width:
    300px;

  height:
    300px;

  background:
    radial-gradient(
      circle,
      rgba(
        59,
        137,
        238,
        0.10
      ),
      transparent 68%
    );
}


.glow-right {
  top:
    80px;

  right:
    -180px;

  width:
    350px;

  height:
    350px;

  background:
    radial-gradient(
      circle,
      rgba(
        126,
        80,
        213,
        0.075
      ),
      transparent 70%
    );
}


/* =========================================================
   HEADER
========================================================= */

.modal-header {
  position:
    relative;

  z-index:
    2;

  display:
    flex;

  align-items:
    flex-start;

  justify-content:
    space-between;

  gap:
    20px;

  padding:
    28px
    30px
    22px;

  border-bottom:
    1px solid
    rgba(
      35,
      50,
      70,
      0.06
    );
}


.header-main {
  min-width:
    0;

  display:
    flex;

  align-items:
    flex-start;

  gap:
    15px;
}


.ai-icon {
  width:
    48px;

  height:
    48px;

  flex:
    0
    0
    48px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3d8ff1,
      #5470e3 54%,
      #805ad2
    );

  border-radius:
    15px;

  box-shadow:
    0
    10px
    25px
    rgba(
      73,
      102,
      217,
      0.22
    );
}


.ai-icon svg {
  width:
    25px;

  height:
    25px;
}


.header-text {
  min-width:
    0;
}


.ai-badge {
  width:
    fit-content;

  margin-bottom:
    7px;

  padding:
    4px
    8px;

  color:
    #676ed0;

  background:
    rgba(
      93,
      101,
      221,
      0.07
    );

  border:
    1px solid
    rgba(
      93,
      101,
      221,
      0.09
    );

  border-radius:
    999px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    8px;

  letter-spacing:
    0.25px;

  text-transform:
    uppercase;
}


.title {
  margin:
    0;

  color:
    #292e35;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size:
    20px;

  line-height:
    1.25;

  letter-spacing:
    -0.35px;
}


.header-description {
  margin:
    7px
    0
    0;

  color:
    #8a919a;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    10px;

  line-height:
    1.45;
}


/* =========================================================
   CLOSE
========================================================= */

.close-btn {
  width:
    34px;

  height:
    34px;

  flex:
    0
    0
    34px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  padding:
    0;

  color:
    #9299a2;

  background:
    #f5f6f8;

  border:
    1px solid
    rgba(
      35,
      50,
      70,
      0.04
    );

  border-radius:
    10px;

  cursor:
    pointer;

  transition:
    color 0.18s ease,
    background-color 0.18s ease,
    transform 0.18s ease;
}


.close-btn:hover {
  color:
    #525a64;

  background:
    #eceef1;

  transform:
    rotate(3deg);
}


.close-btn svg {
  width:
    15px;

  height:
    15px;
}


/* =========================================================
   SCROLL
========================================================= */

.letter-scroll {
  flex:
    1;

  min-height:
    0;

  overflow-y:
    auto;

  padding:
    24px
    30px
    20px;

  scrollbar-width:
    thin;

  scrollbar-color:
    rgba(
      100,
      110,
      125,
      0.18
    )
    transparent;
}


.letter-scroll::-webkit-scrollbar {
  width:
    5px;
}


.letter-scroll::-webkit-scrollbar-track {
  background:
    transparent;
}


.letter-scroll::-webkit-scrollbar-thumb {
  background:
    rgba(
      100,
      110,
      125,
      0.18
    );

  border-radius:
    999px;
}


/* =========================================================
   PAPER
========================================================= */

.letter-paper {
  padding:
    25px
    26px;

  background:
    #fafbfc;

  border:
    1px solid
    rgba(
      32,
      48,
      68,
      0.055
    );

  border-radius:
    17px;

  box-shadow:
    inset
    0
    1px
    0
    rgba(
      255,
      255,
      255,
      0.8
    );
}


/* =========================================================
   SECTION
========================================================= */

.letter-section {
  margin-bottom:
    27px;
}


.letter-section:last-child {
  margin-bottom:
    0;
}


.section-marker {
  display:
    flex;

  align-items:
    center;

  gap:
    7px;

  margin-bottom:
    12px;

  color:
    #8d949c;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    8px;

  letter-spacing:
    0.35px;

  text-transform:
    uppercase;
}


.section-marker > span {
  width:
    5px;

  height:
    5px;

  background:
    linear-gradient(
      135deg,
      #4588e7,
      #755fd5
    );

  border-radius:
    50%;

  box-shadow:
    0
    0
    0
    4px
    rgba(
      80,
      105,
      215,
      0.07
    );
}


/* =========================================================
   BODY
========================================================= */

.letter-body {
  margin:
    0;

  color:
    #555d67;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    12px;

  line-height:
    1.7;

  white-space:
    pre-line;
}


/* =========================================================
   REASONS
========================================================= */

.reasons {
  display:
    flex;

  flex-direction:
    column;

  gap:
    8px;
}


.reason-item {
  display:
    flex;

  align-items:
    flex-start;

  gap:
    9px;

  padding:
    9px
    11px;

  color:
    #59616b;

  background:
    rgba(
      66,
      116,
      190,
      0.035
    );

  border:
    1px solid
    rgba(
      66,
      116,
      190,
      0.055
    );

  border-radius:
    10px;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    11px;

  line-height:
    1.5;
}


.reason-check {
  width:
    18px;

  height:
    18px;

  flex:
    0
    0
    18px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  margin-top:
    1px;

  color:
    #587dcc;

  background:
    rgba(
      76,
      121,
      205,
      0.08
    );

  border-radius:
    6px;
}


.reason-check svg {
  width:
    12px;

  height:
    12px;
}


/* =========================================================
   CLOSING
========================================================= */

.letter-closing {
  margin-top:
    4px;

  padding:
    15px
    17px;

  color:
    #68717c;

  background:
    linear-gradient(
      135deg,
      rgba(
        81,
        125,
        207,
        0.045
      ),
      rgba(
        121,
        83,
        191,
        0.035
      )
    );

  border-left:
    3px solid
    #7085d7;

  border-radius:
    0
    11px
    11px
    0;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    11px;

  font-style:
    italic;

  line-height:
    1.55;

  white-space:
    pre-line;
}


/* =========================================================
   INFO
========================================================= */

.letter-info {
  display:
    flex;

  align-items:
    flex-start;

  gap:
    8px;

  margin-top:
    12px;

  padding:
    10px
    12px;

  color:
    #8b929b;

  background:
    rgba(
      60,
      110,
      180,
      0.035
    );

  border:
    1px solid
    rgba(
      60,
      110,
      180,
      0.055
    );

  border-radius:
    11px;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.45;
}


.info-icon {
  width:
    15px;

  height:
    15px;

  flex:
    0
    0
    15px;

  color:
    #6483ae;
}


.info-icon svg {
  width:
    15px;

  height:
    15px;
}


/* =========================================================
   ACTIONS
========================================================= */

.actions {
  position:
    relative;

  z-index:
    3;

  display:
    flex;

  gap:
    10px;

  padding:
    18px
    30px
    24px;

  background:
    rgba(
      255,
      255,
      255,
      0.97
    );

  border-top:
    1px solid
    rgba(
      35,
      50,
      70,
      0.06
    );
}


.copy-btn,
.send-btn {
  height:
    44px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  border-radius:
    12px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    11px;

  cursor:
    pointer;

  transition:
    transform 0.18s ease,
    background-color 0.18s ease,
    box-shadow 0.18s ease,
    color 0.18s ease;
}


.copy-btn {
  flex:
    0
    0
    150px;

  color:
    #626b76;

  background:
    #f3f5f7;

  border:
    1px solid
    rgba(
      35,
      50,
      70,
      0.055
    );
}


.copy-btn:hover {
  color:
    #424a54;

  background:
    #eceff2;

  transform:
    translateY(-1px);
}


.send-btn {
  flex:
    1;

  gap:
    8px;

  color:
    #ffffff;

  background:
    linear-gradient(
      135deg,
      #3b8df0 0%,
      #4d70df 53%,
      #795cd3 100%
    );

  border:
    none;

  box-shadow:
    0
    8px
    20px
    rgba(
      67,
      93,
      207,
      0.22
    );
}


.send-btn:hover {
  transform:
    translateY(-1px);

  box-shadow:
    0
    11px
    26px
    rgba(
      67,
      93,
      207,
      0.29
    );
}


.send-btn:active,
.copy-btn:active {
  transform:
    scale(0.985);
}


.send-btn svg {
  width:
    15px;

  height:
    15px;
}


.button-inner {
  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  gap:
    7px;
}


.button-inner svg {
  width:
    15px;

  height:
    15px;
}


/* =========================================================
   COPY TOAST
========================================================= */

.copy-toast {
  position:
    absolute;

  left:
    50%;

  bottom:
    83px;

  z-index:
    20;

  display:
    flex;

  align-items:
    center;

  gap:
    7px;

  padding:
    9px
    13px;

  color:
    #ffffff;

  background:
    rgba(
      41,
      47,
      58,
      0.94
    );

  border:
    1px solid
    rgba(
      255,
      255,
      255,
      0.08
    );

  border-radius:
    10px;

  box-shadow:
    0
    8px
    24px
    rgba(
      0,
      0,
      0,
      0.18
    );

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size:
    9px;

  transform:
    translateX(-50%);
}


.copy-toast-icon {
  width:
    17px;

  height:
    17px;

  display:
    flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #ffffff;

  background:
    rgba(
      255,
      255,
      255,
      0.10
    );

  border-radius:
    50%;
}


.copy-toast-icon svg {
  width:
    11px;

  height:
    11px;
}


/* =========================================================
   DARK THEME
========================================================= */

html[data-theme="dark"]
.cover-letter-overlay {
  background:
    rgba(
      3,
      5,
      9,
      0.70
    );
}


html[data-theme="dark"]
.cover-letter-modal {
  background:
    linear-gradient(
      145deg,
      #22242a 0%,
      #1d1f24 100%
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.07
    );

  box-shadow:
    0
    36px
    100px
    rgba(
      0,
      0,
      0,
      0.55
    );
}


html[data-theme="dark"]
.modal-header {
  border-bottom-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.ai-badge {
  color:
    #aea0eb;

  background:
    rgba(
      117,
      91,
      211,
      0.11
    );

  border-color:
    rgba(
      144,
      115,
      221,
      0.12
    );
}


html[data-theme="dark"]
.title {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.header-description {
  color:
    #818892;
}


html[data-theme="dark"]
.close-btn {
  color:
    #858c95;

  background:
    rgba(
      255,
      255,
      255,
      0.045
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.04
    );
}


html[data-theme="dark"]
.close-btn:hover {
  color:
    #e0e2e5;

  background:
    rgba(
      255,
      255,
      255,
      0.075
    );
}


html[data-theme="dark"]
.letter-paper {
  background:
    rgba(
      255,
      255,
      255,
      0.028
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );

  box-shadow:
    inset
    0
    1px
    0
    rgba(
      255,
      255,
      255,
      0.02
    );
}


html[data-theme="dark"]
.section-marker {
  color:
    #6f7680;
}


html[data-theme="dark"]
.letter-body {
  color:
    #c3c7cd;
}


html[data-theme="dark"]
.reason-item {
  color:
    #bec3ca;

  background:
    rgba(
      91,
      135,
      199,
      0.045
    );

  border-color:
    rgba(
      91,
      135,
      199,
      0.07
    );
}


html[data-theme="dark"]
.reason-check {
  color:
    #91afe0;

  background:
    rgba(
      91,
      135,
      210,
      0.10
    );
}


html[data-theme="dark"]
.letter-closing {
  color:
    #a9afb7;

  background:
    linear-gradient(
      135deg,
      rgba(
        84,
        125,
        195,
        0.065
      ),
      rgba(
        120,
        83,
        184,
        0.05
      )
    );

  border-left-color:
    #7587d1;
}


html[data-theme="dark"]
.letter-info {
  color:
    #777f89;

  background:
    rgba(
      73,
      116,
      180,
      0.045
    );

  border-color:
    rgba(
      73,
      116,
      180,
      0.07
    );
}


html[data-theme="dark"]
.info-icon {
  color:
    #819dc5;
}


html[data-theme="dark"]
.actions {
  background:
    rgba(
      29,
      31,
      36,
      0.97
    );

  border-top-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.copy-btn {
  color:
    #b0b5bd;

  background:
    rgba(
      255,
      255,
      255,
      0.045
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.055
    );
}


html[data-theme="dark"]
.copy-btn:hover {
  color:
    #e0e2e5;

  background:
    rgba(
      255,
      255,
      255,
      0.075
    );
}


html[data-theme="dark"]
.letter-scroll {
  scrollbar-color:
    rgba(
      255,
      255,
      255,
      0.12
    )
    transparent;
}


html[data-theme="dark"]
.letter-scroll::-webkit-scrollbar-thumb {
  background:
    rgba(
      255,
      255,
      255,
      0.12
    );
}


/* =========================================================
   TRANSITIONS
========================================================= */

.button-content-enter-active,
.button-content-leave-active {
  transition:
    opacity 0.16s ease,
    transform 0.16s ease;
}


.button-content-enter-from {
  opacity:
    0;

  transform:
    translateY(3px);
}


.button-content-leave-to {
  opacity:
    0;

  transform:
    translateY(-3px);
}


.copy-toast-enter-active,
.copy-toast-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}


.copy-toast-enter-from,
.copy-toast-leave-to {
  opacity:
    0;

  transform:
    translateX(-50%)
    translateY(6px);
}


/* =========================================================
   ANIMATION
========================================================= */

@keyframes modal-appearance {

  from {
    opacity:
      0;

    transform:
      translateY(12px)
      scale(0.985);
  }

  to {
    opacity:
      1;

    transform:
      translateY(0)
      scale(1);
  }

}


/* =========================================================
   MOBILE
========================================================= */

@media (max-width: 430px) {

  .cover-letter-overlay {
    padding:
      12px;
  }


  .cover-letter-modal {
    width:
      100%;

    max-width:
      100%;

    max-height:
      calc(100vh - 24px);

    border-radius:
      20px;
  }


  .modal-header {
    padding:
      22px
      20px
      18px;
  }


  .ai-icon {
    width:
      42px;

    height:
      42px;

    flex-basis:
      42px;

    border-radius:
      13px;
  }


  .title {
    font-size:
      17px;
  }


  .header-description {
    font-size:
      9px;
  }


  .letter-scroll {
    padding:
      18px
      20px
      16px;
  }


  .letter-paper {
    padding:
      20px
      18px;
  }


  .letter-body {
    font-size:
      11px;
  }


  .actions {
    padding:
      15px
      20px
      20px;

    gap:
      8px;
  }


  .copy-btn {
    flex:
      0
      0
      112px;
  }


  .copy-btn,
  .send-btn {
    height:
      42px;

    font-size:
      10px;
  }


  .copy-toast {
    bottom:
      74px;
  }

}

</style>